import { Pipe, PipeTransform } from '@angular/core';
import { IDatePlace } from '../models/location.model';
import { DateService } from '../services/date/date.service';

@Pipe({ name: 'uniqueDates',pure:false })
export class UniqueDatesPipe implements PipeTransform {
  constructor(private dateService:DateService){

  }
  transform(datesPlaces: IDatePlace[]) {
    const dates = datesPlaces.map(item => this.dateService.formatDatePlaceToDateShort(item, true));
    const uniqueDates = [...new Set(dates)];
    return uniqueDates;
  }
}